<button class="btn-lang" [class]="isClass()" [matMenuTriggerFor]="menu" [disabled]="hideLang">
    <span>{{languageService.appLanguage}}</span>
</button>
<mat-menu #menu="matMenu" panelClass="menu-panel-language" class="customize menu-panel-language">
    @for (item of languageService.languageGroup; track $index) {
        @for (lang of item.languages; track lang) {
            @if(languageService.appLanguage === lang.name){
                <button mat-menu-item class="item-menu active-menu" (click)="languageService.setLanguage(lang.name)" [disabled]="lang.disabled">{{ lang.name }}</button>
            }@else{
                <button mat-menu-item class="item-menu" (click)="languageService.setLanguage(lang.name)" [disabled]="lang.disabled">{{ lang.name }}</button>
            }
        }
    }
</mat-menu>
